export const hasHsRouteKeyCookie = (): boolean => {
  if (typeof document === 'undefined') {
    return false;
  }
  return document.cookie
    .split(';')
    .some((entry) => entry.trimStart().startsWith('hs_route_key_'));
};
